<form #customQuestionsFormModel="ngForm" [attr.data-test-id]="testId + '.form'">

    <!-- ===== Additional Questions (customQuestions) ===== -->
    <ng-container *ngIf="customQuestions.length > 0">
		<div class="m-form__group mb-32">
			<h2 class="section-title" [attr.data-test-id]="testId + '.custom-questions-title'">Additional Questions:</h2>
			<div class="vertical-stack-20">
				<ng-container *ngFor="let obj of customQuestions; let i = index">
					<savvy-card [hoverable]="false" [attr.data-test-id]="testId + '.custom-question-card.' + i">
						<p class="sub-headline-2" *ngIf="obj.type !== 'select'" [innerHTML]="obj.question" [attr.data-test-id]="testId + '.custom-question-text.' + i"></p>
						<small *ngIf="obj.description && obj.type !== 'checkbox'" class="description" [innerHTML]="obj.description" [attr.data-test-id]="testId + '.custom-question-description.' + i"></small>

							<mat-form-field class="mat-form-field-fluid"
											*ngIf="obj.type === 'select'">
								<mat-label
									class="d-block" [attr.data-test-id]="testId + '.select-label.' + i" [innerHTML]="obj.question">
								</mat-label>
								<mat-select name="selectCustomQuestion_{{i + 1}}"
											id="selectCustomQuestion_{{i + 1}}"
											[(ngModel)]="obj.answer"
											[required]="obj.required"
											(selectionChange)="onParentChange(obj)"
											#ngCustomQuestion="ngModel"
											[attr.data-test-id]="testId + '.select-input.' + i">
									<mat-option *ngFor="let opt of obj.options"
												[value]="opt.value"
												[attr.data-test-id]="testId + '.select-option.' + i + '.' + opt.value?.toLowerCase()">{{ opt.title }}
									</mat-option>
								</mat-select>
								<mat-error
									*ngIf="ngCustomQuestion.hasError('required') && !obj.answer && (customQuestionsFormModel.submitted || (ngCustomQuestion.dirty || ngCustomQuestion.touched))"
									[attr.data-test-id]="testId + '.select.required-error.' + i">
									Please select an option.
								</mat-error>
							</mat-form-field>

							<mat-form-field class="mat-form-field-fluid"
											*ngIf="obj.type === 'textArea'">
								<textarea matInput type="text"
										  name="txtAreaCustomQuestion_{{i + 1}}"
										  [(ngModel)]="obj.answer" maxlength="100"
										  id="txtAreaCustomQuestion_{{i + 1}}" autocomplete="off"
										  #ngCustomQuestion="ngModel"
										  [required]="obj.required"
										  [attr.data-test-id]="testId + '.textarea-input.' + i"></textarea>
								<mat-error
									*ngIf="ngCustomQuestion.hasError('required')"
									[attr.data-test-id]="testId + '.textarea.required-error.' + i">
									Please enter details.
								</mat-error>
								<mat-error
									*ngIf="ngCustomQuestion.hasError('min-max')"
									[attr.data-test-id]="testId + '.textarea.min-max-error.' + i">
									Value must be between {{ obj.min || 0 }}
									and {{ obj.max || 0 }}.
								</mat-error>
							</mat-form-field>

							<mat-form-field class="mat-form-field-fluid" *ngIf="obj.type === 'text'">
								<input matInput type="text" name="txtCustomQuestion_{{i + 1}}"
									   [(ngModel)]="obj.answer" maxlength="15"
									   id="txtCustomQuestion_{{i + 1}}"
									   autocomplete="off"
									   #ngCustomQuestion="ngModel"
									   [required]="obj.required"
									   [attr.data-test-id]="testId + '.text-input.' + i">
								<mat-error *ngIf="ngCustomQuestion.hasError('required')"
										   [attr.data-test-id]="testId + '.text.required-error.' + i">
									Please enter details.
								</mat-error>
								<mat-error *ngIf="ngCustomQuestion.hasError('min-max')"
										   [attr.data-test-id]="testId + '.text.min-max-error.' + i">
									Value must be between {{ obj.min || 0 }}
									and {{ obj.max || 0 }}.
								</mat-error>
							</mat-form-field>

							<mat-form-field class="mat-form-field-fluid" *ngIf="obj.type === 'number'">
								<mat-label
									class="d-block" [attr.data-test-id]="testId + '.number-label.' + i">{{ obj.question }}
								</mat-label>
								<input matInput type="number" name="customQuestion_{{i + 1}}"
									   id="customQuestion_{{i + 1}}"
									   [(ngModel)]="obj.answer" maxlength="50"
									   autocomplete="off"
									   #ngCustomQuestion="ngModel"
									   [required]="obj.required"
									   [min]="obj.min"
									   [max]="obj.max"
									   [attr.data-test-id]="testId + '.number-input.' + i">
								<mat-error *ngIf="ngCustomQuestion.hasError('required')"
										   [attr.data-test-id]="testId + '.number.required-error.' + i">
									Please enter details.
								</mat-error>
								<mat-error *ngIf="ngCustomQuestion.hasError('min')"
										   [attr.data-test-id]="testId + '.number.min-error.' + i">
									Value cannot be less than {{ obj.min || 0 }}.
								</mat-error>
								<mat-error *ngIf="ngCustomQuestion.hasError('max')"
										   [attr.data-test-id]="testId + '.number.max-error.' + i">
									Value cannot be greater than {{ obj.max || 0 }}.
								</mat-error>
							</mat-form-field>

							<div *ngIf="obj.type === 'radio'">
								<small class="d-block mb-12" *ngIf="obj.hint" [attr.data-test-id]="testId + '.radio-hint.' + i" [innerHTML]="obj.hint"></small>
								<div class="label-check-box">
									<mat-radio-group
										id="radioCustomQuestion_{{i + 1}}"
										class="vertical-radio-group"
										[(ngModel)]="obj.answer"
										name="radioCustomQuestion_{{i + 1}}"
										#ngCustomQuestion="ngModel"
										[required]="obj.required"
										[attr.data-test-id]="testId + '.radio-group.' + i">
										<mat-radio-button *ngFor="let opt of obj.options"
														  [value]="opt.value"
														  [attr.data-test-id]="testId + '.radio-option.' + i + '.' + opt.value?.toLowerCase()">
											<span class="form-option-label" [attr.data-test-id]="testId + '.radio-option-label.' + i + '.' + opt.value?.toLowerCase()">{{ opt.title }}</span>
										</mat-radio-button>
									</mat-radio-group>
								</div>
								<mat-error class="text-start mt-2"
									*ngIf="ngCustomQuestion.hasError('required') && !obj.answer && (customQuestionsFormModel.submitted || (ngCustomQuestion.dirty || ngCustomQuestion.touched))"
									[attr.data-test-id]="testId + '.radio.required-error.' + i">
									Please select an option.
								</mat-error>
							</div>

							<div *ngIf="obj.type === 'checkbox'">
								<mat-checkbox
									#ngCustomQuestion="ngModel"
									name="checkboxCustomQuestion_{{i + 1}}"
									id="checkboxCustomQuestion_{{i + 1}}"
									[(ngModel)]="obj.answer"
									[attr.data-test-id]="testId + '.checkbox-input.' + i">
									<div style="white-space: pre-line;">
										<strong>{{ obj.question }}</strong><br>
										{{ obj.description }}
									</div>
								</mat-checkbox>
							</div>

							<div *ngIf="obj.type === 'multi-checkbox'">
								<div class="d-flex flex-wrap flex-sm-row flex-column gap-3">
									<mat-checkbox
										*ngFor="let opt of obj.options; let optIndex = index"
										name="multiCheckbox_{{i + 1}}_{{optIndex + 1}}"
										id="multiCheckbox_{{i + 1}}_{{optIndex + 1}}"
										[checked]="isCheckboxSelected(obj.answer, opt.value)"
										(change)="onCheckboxChange(obj, opt.value, $event.checked);
													onParentChange(obj)"
										class="checkbox-item mx-2"
										[attr.data-test-id]="testId + '.multi-checkbox-option.' + i + '.' + optIndex">
										{{ opt.title }}
									</mat-checkbox>
								</div>
								<mat-error class="d-block"
									*ngIf="obj.required && (customQuestionsFormModel.submitted || obj.touched) && (!obj.answer || obj.answer.length === 0)"
									[attr.data-test-id]="testId + '.multi-checkbox.required-error.' + i">
									Please select at least one option.
								</mat-error>
							</div>

						<!-- Inline sub-questions -->
						<ng-container
							*ngFor="let sub of (obj.subQuestions || []); let i2 = index">
							<ng-container *ngIf="isAnswerMatched(obj.answer, sub.ifAns)">
								<mat-form-field class="mat-form-field-fluid"
												*ngIf="sub.type === 'select'">
									<mat-label
										class="d-block" [innerHTML]="sub.question" [attr.data-test-id]="testId + '.sub-select-label.' + i + '.' + i2">
									</mat-label>
									<mat-select
										name="selectSubCustomQuestion_{{i + 1}}_{{i2 + 1}}"
										[(ngModel)]="sub.answer"
										[required]="sub.required"
										id="selectSubCustomQuestion_{{i + 1}}_{{i2 + 1}}"
										(selectionChange)="onParentChange(sub)"
										#ngSubCustomQuestion="ngModel"
										[attr.data-test-id]="testId + '.sub-select-input.' + i + '.' + i2">
										<mat-option *ngFor="let opt of sub.options"
													[value]="opt.value"
													[attr.data-test-id]="testId + '.sub-select-option.' + i + '.' + i2 + '.' + opt.value?.toLowerCase()">{{ opt.title }}
										</mat-option>
									</mat-select>
									<mat-error
										*ngIf="ngSubCustomQuestion.hasError('required') && (customQuestionsFormModel.submitted || (ngSubCustomQuestion.dirty || ngSubCustomQuestion.touched))"
										[attr.data-test-id]="testId + '.sub-select.required-error.' + i + '.' + i2">
										Please select an option.
									</mat-error>
								</mat-form-field>
								<mat-form-field class="mat-form-field-fluid"
												*ngIf="sub.type === 'textArea'">
									<mat-label
										class="d-block" [innerHTML]="sub.question" [attr.data-test-id]="testId + '.sub-textarea-label.' + i + '.' + i2">
									</mat-label>
									<textarea matInput type="text"
											  name="txtAreaSubCustomQuestion_{{i + 1}}_{{i2 + 1}}"
											  [(ngModel)]="sub.answer" maxlength="100"
											  id="txtAreaSubCustomQuestion_{{i + 1}}_{{i2 + 1}}"
											  autocomplete="off"
											  #ngSubCustomQuestion="ngModel"
											  [required]="sub.required"
											  [attr.data-test-id]="testId + '.sub-textarea-input.' + i + '.' + i2"></textarea>
									<mat-error
										*ngIf="ngSubCustomQuestion.hasError('required')"
										[attr.data-test-id]="testId + '.sub-textarea.required-error.' + i + '.' + i2">
										Please enter details.
									</mat-error>
									<mat-error
										*ngIf="ngSubCustomQuestion.hasError('min-max')"
										[attr.data-test-id]="testId + '.sub-textarea.min-max-error.' + i + '.' + i2">
										Value must be between {{ sub.min || 0 }}
										and {{ sub.max || 0 }}.
									</mat-error>
								</mat-form-field>
								<mat-form-field class="mat-form-field-fluid" *ngIf="sub.type === 'text'">
									<mat-label
										class="d-block" [innerHTML]="sub.question" [attr.data-test-id]="testId + '.sub-text-label.' + i + '.' + i2">
									</mat-label>
									<input matInput type="text" name="txtSubCustomQuestion_{{i + 1}}_{{i2 + 1}}"
										   [(ngModel)]="sub.answer" maxlength="15"
										   id="txtSubCustomQuestion_{{i + 1}}_{{i2 + 1}}"
										   autocomplete="off"
										   #ngSubCustomQuestion="ngModel"
										   [required]="sub.required"
										   [attr.data-test-id]="testId + '.sub-text-input.' + i + '.' + i2">
									<mat-error *ngIf="ngSubCustomQuestion.hasError('required')"
											   [attr.data-test-id]="testId + '.sub-text.required-error.' + i + '.' + i2">
										Please enter details.
									</mat-error>
									<mat-error *ngIf="ngSubCustomQuestion.hasError('min-max')"
											   [attr.data-test-id]="testId + '.sub-text.min-max-error.' + i + '.' + i2">
										Value must be between {{ sub.min || 0 }}
										and {{ sub.max || 0 }}.
									</mat-error>
								</mat-form-field>
								<mat-form-field class="mat-form-field-fluid" *ngIf="sub.type === 'allowNumberOnly'">
									<mat-label
										class="d-block" [innerHTML]="sub.question" [attr.data-test-id]="testId + '.sub-number-only-label.' + i + '.' + i2">
									</mat-label>
									<input matInput type="tel" name="telNumCustomQuestion_{{i + 1}}_{{i2 + 1}}"
										   [(ngModel)]="sub.answer" maxlength="15"
										   id="telNumCustomQuestion_{{i + 1}}_{{i2 + 1}}"
										   autocomplete="off" input-num
										   #ngSubCustomQuestion="ngModel"
										   [required]="sub.required"
										   [attr.data-test-id]="testId + '.sub-number-only-input.' + i + '.' + i2">
									<mat-error *ngIf="ngSubCustomQuestion.hasError('required')"
											   [attr.data-test-id]="testId + '.sub-number-only.required-error.' + i + '.' + i2">
										Please enter details.
									</mat-error>
									<mat-error *ngIf="ngSubCustomQuestion.hasError('min-max')"
											   [attr.data-test-id]="testId + '.sub-number-only.min-max-error.' + i + '.' + i2">
										Value must be between {{ sub.min || 0 }}
										and {{ sub.max || 0 }}.
									</mat-error>
								</mat-form-field>

								<mat-form-field class="mat-form-field-fluid" *ngIf="sub.type === 'number'">
									<mat-label
										class="d-block" [attr.data-test-id]="testId + '.sub-number-label.' + i + '.' + i2">{{ sub.question }} 
									</mat-label>
									<input matInput type="number" name="customQuestion_{{i + 1}}_{{i2 + 1}}"
										   id="customQuestion_{{i + 1}}_{{i2 + 1}}"
										   [(ngModel)]="sub.answer" maxlength="50"
										   autocomplete="off"
										   #ngCustomQuestion="ngModel"
										   [required]="sub.required"
										   [min]="sub.min"
										   [max]="sub.max"
										   [attr.data-test-id]="testId + '.sub-number-input.' + i + '.' + i2">
									<mat-error *ngIf="ngCustomQuestion.hasError('required')"
											   [attr.data-test-id]="testId + '.sub-number.required-error.' + i + '.' + i2">
										Please enter details.
									</mat-error>
									<mat-error *ngIf="ngCustomQuestion.hasError('min')"
											   [attr.data-test-id]="testId + '.sub-number.min-error.' + i + '.' + i2">
										Value cannot be less than {{ sub.min || 0 }}.
									</mat-error>
									<mat-error *ngIf="ngCustomQuestion.hasError('max')"
											   [attr.data-test-id]="testId + '.sub-number.max-error.' + i + '.' + i2">
										Value cannot be greater than {{ sub.max || 0 }}.
									</mat-error>
								</mat-form-field>

								<div *ngIf="sub.type === 'telNumber'">
									<creditsnap-phone-number
										[(ngModel)]="sub.answer"
										name="customQuestionPhoneNumber_{{i + 1}}"
										id="customQuestionPhoneNumber_{{i + 1}}"
										[options]="phoneOptions"
										#ngPhone="ngModel"
										[required]="sub.required"
										[attr.data-test-id]="testId + '.sub-phone-input.' + i + '.' + i2">
									</creditsnap-phone-number>
								</div>

								<div *ngIf="sub.type === 'radio'">
									<p class="sub-headline-2 mb-12" [attr.data-test-id]="testId + '.sub-radio-question.' + i + '.' + i2" [innerHTML]="sub.question"></p>
									<small class="font-black" *ngIf="sub.hint" [attr.data-test-id]="testId + '.sub-radio-hint.' + i + '.' + i2" [innerHTML]="sub.hint"></small>
									<div class="label-check-box">
										<mat-radio-group class="vertical-radio-group" [(ngModel)]="sub.answer"
														 name="radioSubCustomQuestion_{{i + 1}}_{{i2 + 1}}" #ngCustomQuestion="ngModel"
														 id="radioSubCustomQuestion_{{i + 1}}_{{i2 + 1}}"
														 [required]="sub.required"
														 [attr.data-test-id]="testId + '.sub-radio-group.' + i + '.' + i2">
											<mat-radio-button *ngFor="let opt of sub.options" [value]="opt.value"
															  [attr.data-test-id]="testId + '.sub-radio-option.' + i + '.' + i2 + '.' + opt.value?.toLowerCase()">
												<span class="form-option-label">{{ opt.title }}</span>
											</mat-radio-button>
										</mat-radio-group>
									</div>
									<mat-error class="text-start mt-2"
										*ngIf="ngCustomQuestion.hasError('required') && !sub.answer && (customQuestionsFormModel.submitted || (ngCustomQuestion.dirty || ngCustomQuestion.touched))"
										[attr.data-test-id]="testId + '.sub-radio.required-error.' + i + '.' + i2">
										Please select an option.
									</mat-error>
								</div>

								<div *ngIf="sub.type === 'checkbox'">
									<mat-checkbox
										#ngSubCustomQuestion="ngModel"
										name="checkboxSubCustomQuestion_{{i + 1}}_{{i2 + 1}}"
										id="checkboxSubCustomQuestion_{{i + 1}}_{{i2 + 1}}"
										[(ngModel)]="sub.answer"
										[required]="sub.required"
										[attr.data-test-id]="testId + '.sub-checkbox-input.' + i + '.' + i2">
										<div style="white-space: pre-line;">
											<strong>{{ sub.question }}</strong><br>
											{{ sub.description }}
										</div>
									</mat-checkbox>
								</div>

								<div *ngIf="sub.type === 'multi-checkbox'">
									<div class="d-flex flex-wrap flex-sm-row flex-column gap-3">
										<mat-checkbox
											*ngFor="let opt of sub.options; let subOptIndex = index"
											name="multiCheckboxSub_{{i + 1}}_{{i2 + 1}}_{{subOptIndex + 1}}"
											id="multiCheckboxSub_{{i + 1}}_{{i2 + 1}}_{{subOptIndex + 1}}"
											[checked]="isCheckboxSelected(sub.answer, opt.value)"
											(change)="onCheckboxChange(sub, opt.value, $event.checked);
													onParentChange(sub)"
											[attr.data-test-id]="testId + '.sub-multi-checkbox-option.' + i + '.' + i2 + '.' + subOptIndex">
											{{ opt.title }}
										</mat-checkbox>
									</div>
									<mat-error class="d-block"
										*ngIf="sub.required && (customQuestionsFormModel.submitted || sub.touched) && (!sub.answer || sub.answer.length === 0)"
										[attr.data-test-id]="testId + '.sub-multi-checkbox.required-error.' + i + '.' + i2">
										Please select at least one option.
									</mat-error>
								</div>

								<!-- Grand sub-questions -->
								<ng-container *ngFor="let grandSub of (sub.subQuestions || []); let i3 = index">
									<ng-container *ngIf="isAnswerMatched(sub.answer, grandSub.ifAns)">

										<p class="sub-headline-2" *ngIf="grandSub.type !== 'radio' && grandSub.type !== 'checkbox'"
										   [innerHTML]="grandSub.question" [attr.data-test-id]="testId + '.grand-sub-text.' + i + '.' + i2 + '.' + i3"></p>
										<small *ngIf="grandSub.description && grandSub.type !== 'radio' && grandSub.type !== 'checkbox'"
											   class="description" [innerHTML]="grandSub.description"></small>

										<mat-form-field class="mat-form-field-fluid"
														*ngIf="grandSub.type === 'select'">
											<mat-label [attr.data-test-id]="testId + '.grand-sub-select-label.' + i + '.' + i2 + '.' + i3">Select an option</mat-label>
											<mat-select
												name="selectGrandSubCustomQuestion_{{i + 1}}_{{i2 + 1}}_{{i3 + 1}}"
												id="selectGrandSubCustomQuestion_{{i + 1}}_{{i2 + 1}}_{{i3 + 1}}"
												[(ngModel)]="grandSub.answer"
												[required]="grandSub.required"
												#ngGrandSubCustomQuestion="ngModel"
												[matTooltip]="grandSub.question"
												[attr.data-test-id]="testId + '.grand-sub-select-input.' + i + '.' + i2 + '.' + i3">
												<mat-option
													*ngFor="let opt of grandSub.options"
													[value]="opt.value"
													[attr.data-test-id]="testId + '.grand-sub-select-option.' + i + '.' + i2 + '.' + i3 + '.' + opt.value?.toLowerCase()">{{ opt.title }}
												</mat-option>
											</mat-select>
										</mat-form-field>

										<mat-form-field class="mat-form-field-fluid"
														*ngIf="grandSub.type === 'textArea'">
											<mat-label [attr.data-test-id]="testId + '.grand-sub-textarea-label.' + i + '.' + i2 + '.' + i3">Enter details</mat-label>
											<textarea matInput type="text"
													  name="grandSubTextAreaCustomQuestion_{{i + 1}}_{{i2 + 1}}_{{i3 + 1}}"
													  id="grandSubTextAreaCustomQuestion_{{i + 1}}_{{i2 + 1}}_{{i3 + 1}}"
													  [(ngModel)]="grandSub.answer"
													  [matTooltip]="grandSub.question"
													  maxlength="100"
													  autocomplete="off"
													  #ngGrandSubCustomQuestion="ngModel"
													  [required]="grandSub.required"
													  [attr.data-test-id]="testId + '.grand-sub-textarea-input.' + i + '.' + i2 + '.' + i3"></textarea>
											<mat-error *ngIf="ngGrandSubCustomQuestion.hasError('required')"
													   [attr.data-test-id]="testId + '.grand-sub-textarea.required-error.' + i + '.' + i2 + '.' + i3">
												Please enter details.
											</mat-error>
											<mat-error *ngIf="ngGrandSubCustomQuestion.hasError('min-max')"
													   [attr.data-test-id]="testId + '.grand-sub-textarea.min-max-error.' + i + '.' + i2 + '.' + i3">
												Value must be between {{ grandSub.min || 0 }}
												and {{ grandSub.max || 0 }}.
											</mat-error>
										</mat-form-field>

										<mat-form-field class="mat-form-field-fluid" *ngIf="grandSub.type === 'text'">
											<mat-label [attr.data-test-id]="testId + '.grand-sub-text-label.' + i + '.' + i2 + '.' + i3">Enter details</mat-label>
											<input matInput type="text"
												   name="grandSubTextCustomQuestion_{{i + 1}}_{{i2 + 1}}_{{i3 + 1}}"
												   id="grandSubTextCustomQuestion_{{i + 1}}_{{i2 + 1}}_{{i3 + 1}}"
												   [(ngModel)]="grandSub.answer" maxlength="15"
												   autocomplete="off"
												   #ngGrandSubCustomQuestion="ngModel"
												   [required]="grandSub.required"
												   [attr.data-test-id]="testId + '.grand-sub-text-input.' + i + '.' + i2 + '.' + i3">
											<mat-error *ngIf="ngGrandSubCustomQuestion.hasError('required')"
													   [attr.data-test-id]="testId + '.grand-sub-text.required-error.' + i + '.' + i2 + '.' + i3">
												Please enter details.
											</mat-error>
											<mat-error *ngIf="ngGrandSubCustomQuestion.hasError('min-max')"
													   [attr.data-test-id]="testId + '.grand-sub-text.min-max-error.' + i + '.' + i2 + '.' + i3">
												Value must be between {{ obj.min || 0 }}
												and {{ obj.max || 0 }}.
											</mat-error>
										</mat-form-field>

										<mat-form-field class="mat-form-field-fluid" *ngIf="grandSub.type === 'number'">
											<input matInput type="number" name="customQuestion_{{i + 1}}_{{i2 + 1}}_{{i3 + 1}}"
												   id="customQuestion_{{i + 1}}_{{i2 + 1}}_{{i3 + 1}}"
												   [(ngModel)]="grandSub.answer" maxlength="50"
												   autocomplete="off"
												   #ngCustomQuestion="ngModel"
												   [required]="grandSub.required"
												   [min]="grandSub.min"
												   [max]="grandSub.max"
												   [attr.data-test-id]="testId + '.grand-sub-number-input.' + i + '.' + i2 + '.' + i3">
											<mat-error *ngIf="ngCustomQuestion.hasError('required')"
													   [attr.data-test-id]="testId + '.grand-sub-number.required-error.' + i + '.' + i2 + '.' + i3">
												Please enter details.
											</mat-error>
											<mat-error *ngIf="ngCustomQuestion.hasError('min')"
													   [attr.data-test-id]="testId + '.grand-sub-number.min-error.' + i + '.' + i2 + '.' + i3">
												Value cannot be less than {{ grandSub.min || 0 }}.
											</mat-error>
											<mat-error *ngIf="ngCustomQuestion.hasError('max')"
													   [attr.data-test-id]="testId + '.grand-sub-number.max-error.' + i + '.' + i2 + '.' + i3">
												Value cannot be greater than {{ grandSub.max || 0 }}.
											</mat-error>
										</mat-form-field>

										<div *ngIf="grandSub.type === 'radio'">
											<p class="sub-headline-2" [attr.data-test-id]="testId + '.grand-sub-radio-question.' + i + '.' + i2 + '.' + i3" [innerHTML]="grandSub.question"></p>
											<div class="label-check-box">
												<mat-radio-group class="vertical-radio-group"
																 [(ngModel)]="grandSub.answer"
																 name="grandSubRadioCustomQuestion_{{i + 1}}_{{i2 + 1}}_{{i3 + 1}}"
																 #ngGrandSubCustomQuestion="ngModel"
																 id="grandSubRadioCustomQuestion_{{i + 1}}_{{i2 + 1}}_{{i3 + 1}}"
																 [required]="grandSub.required"
																 [attr.data-test-id]="testId + '.grand-sub-radio-group.' + i + '.' + i2 + '.' + i3">
													<mat-radio-button *ngFor="let opt of grandSub.options"
																	  [value]="opt.value"
																	  [attr.data-test-id]="testId + '.grand-sub-radio-option.' + i + '.' + i2 + '.' + i3 + '.' + opt.value?.toLowerCase()">
														<span class="form-option-label">{{ opt.title }}</span>
													</mat-radio-button>
												</mat-radio-group>
											</div>
											<mat-error
												*ngIf="ngGrandSubCustomQuestion.hasError('required') && !obj.answer && (customQuestionsFormModel.submitted || (ngGrandSubCustomQuestion.dirty || ngGrandSubCustomQuestion.touched))"
												[attr.data-test-id]="testId + '.grand-sub-radio.required-error.' + i + '.' + i2 + '.' + i3">
												Please select an option.
											</mat-error>
										</div>

										<div *ngIf="grandSub.type === 'checkbox'" [attr.data-test-id]="testId + '.grand-sub-checkbox-container.' + i + '.' + i2 + '.' + i3">
											<mat-checkbox
												#ngGrandSubCustomQuestion="ngModel"
												name="checkboxGrandSubCustomQuestion_{{i + 1}}_{{i2 + 1}}_{{i3 + 1}}"
												id="checkboxGrandSubCustomQuestion_{{i + 1}}_{{i2 + 1}}_{{i3 + 1}}"
												[(ngModel)]="grandSub.answer"
												[attr.data-test-id]="testId + '.grand-sub-checkbox-input.' + i + '.' + i2 + '.' + i3">
												<div style="white-space: pre-line;">
													<strong>{{ grandSub.question }}</strong><br>
													{{ grandSub.description }}
												</div>
											</mat-checkbox>
										</div>

										<div *ngIf="grandSub.type === 'multi-checkbox'" >
											<label class="d-block mb-2" [attr.data-test-id]="testId + '.grand-sub-multi-checkbox-label.' + i + '.' + i2 + '.' + i3" [innerHTML]="grandSub.question"></label>
											<div class="checkbox-group">
												<mat-checkbox
													*ngFor="let opt of grandSub.options; let grandSubIndex = index"
													name="multiCheckboxGrandSub_{{i + 1}}_{{i2 + 1}}_{{i3 + 1}}_{{grandSubIndex + 1}}"
													id="multiCheckboxGrandSub_{{i + 1}}_{{i2 + 1}}_{{i3 + 1}}_{{grandSubIndex + 1}}"
													[checked]="isCheckboxSelected(grandSub.answer, opt.value)"
													(change)="onCheckboxChange(grandSub, opt.value, $event.checked)"
													class="checkbox-item mx-2"
													[attr.data-test-id]="testId + '.grand-sub-multi-checkbox-option.' + i + '.' + i2 + '.' + i3 + '.' + grandSubIndex">
													{{ opt.title }}
												</mat-checkbox>
											</div>
											<mat-error class="d-block"
												*ngIf="grandSub.required && (customQuestionsFormModel.submitted || grandSub.touched) && (!grandSub.answer || grandSub.answer.length === 0)"
												[attr.data-test-id]="testId + '.grand-sub-multi-checkbox.required-error.' + i + '.' + i2 + '.' + i3">
												Please select at least one option.
											</mat-error>
										</div>
									</ng-container>
								</ng-container>
							</ng-container>
						</ng-container>
					</savvy-card>
				</ng-container>
			</div>
		</div>
    </ng-container>

    <!-- ===== Declaration Questions ===== -->
    <ng-container *ngIf="declarationQuestions?.length > 0">
        <div class="m-form__group mb-32">
            <ng-container *ngIf="!(keyIdentifier.loanPurposeConfig?.isBusinessProduct); else businessCustomQuestions">
                <h2 class="subtitle mb-18" [attr.data-test-id]="testId + '.declaration-title'">Declarations
                    <span class="m--regular-font-size-lg2 font-weight-normal" [attr.data-test-id]="testId + '.declaration-applicant-name-value'">{{ applicantName | titlecase }}</span>
                </h2>
            </ng-container>
            <ng-template #businessCustomQuestions>
                <h2 class="subtitle mb-18" [attr.data-test-id]="testId + '.declaration-business-title'">Declarations</h2>
            </ng-template>

            <div class="vertical-stack-20">
                <ng-container *ngFor="let question of declarationQuestions; let i=index">

                    <savvy-card [hoverable]="false" [attr.data-test-id]="testId + '.declaration-card.' + i">
                        <p class="sub-headline-2" [attr.data-test-id]="testId + '.declaration-question.' + i">{{ question.question }}</p>
                        <div class="label-check-box">
                            <mat-radio-group #questionModel="ngModel"
                                             [(ngModel)]="question.answer"
                                             name="q{{i+1}}" required
                                             [attr.data-test-id]="testId + '.declaration-radio-group.' + i">
                                <mat-radio-button value="yes" [attr.data-test-id]="testId + '.declaration-radio-yes.' + i">
                                    <span class="form-option-label">Yes</span>
                                </mat-radio-button>
                                <mat-radio-button value="no" [attr.data-test-id]="testId + '.declaration-radio-no.' + i">
                                    <span class="form-option-label">No</span>
                                </mat-radio-button>
                            </mat-radio-group>
                            <mat-error
                                *ngIf="questionModel.invalid && (customQuestionsFormModel.submitted || (questionModel.dirty || questionModel.touched))"
                                [attr.data-test-id]="testId + '.declaration-radio.required-error.' + i">
                                Please select an option.
                            </mat-error>
                        </div>
                    </savvy-card>

                    <!-- Sub-questions -->
                    <ng-container *ngIf="question.answer === 'yes' && question.subQuestions">
                        <savvy-card [hoverable]="false" *ngFor="let subQuestion of question.subQuestions; let j=index"
                                    [attr.data-test-id]="testId + '.declaration-sub-card.' + i + '.' + j">
                            <p class="sub-headline-2" [attr.data-test-id]="testId + '.declaration-sub-question.' + i + '.' + j">Q{{ i + 1 }}-{{ getAlphabetFromNumber(j) }}. {{ subQuestion.question }}</p>
                            <mat-form-field class="mat-form-field-fluid">
                                <mat-label [attr.data-test-id]="testId + '.declaration-sub-select-label.' + i + '.' + j">{{ subQuestion.question }}</mat-label>
                                <mat-select [(ngModel)]="subQuestion.answer"
                                            name="q{{i + 1}}-{{getAlphabetFromNumber(j)}}"
                                            required
                                            [attr.data-test-id]="testId + '.declaration-sub-select-input.' + i + '.' + j">
                                    <mat-option *ngFor="let option of subQuestion.options"
                                                [value]="option"
                                                [attr.data-test-id]="testId + '.declaration-sub-select-option.' + i + '.' + j + '.' + option?.toLowerCase()">
                                        {{ option }}
                                    </mat-option>
                                </mat-select>
                                <mat-error [attr.data-test-id]="testId + '.declaration-sub-select.required-error.' + i + '.' + j">Please select a year first.</mat-error>
                            </mat-form-field>
                        </savvy-card>
                    </ng-container>

                </ng-container>
            </div>
        </div>
    </ng-container>

    <!-- ===== Assets & Liabilities ===== -->
    <ng-container *ngIf="assetsQuestions?.length > 0">
        <div class="m-form__group mb-32">
            <h2 class="section-title" [attr.data-test-id]="testId + '.assets-title'">Assets & Liabilities:</h2>
            <div class="vertical-stack-20">
                <savvy-card [hoverable]="false" *ngFor="let question of assetsQuestions; let i=index"
                            [attr.data-test-id]="testId + '.assets-card.' + i">
                    <p class="sub-headline-2" [attr.data-test-id]="testId + '.assets-question.' + i">Q{{ i + 1 }}. {{ question.question }}</p>
                    <mat-form-field class="mat-form-field-fluid">
                        <mat-label [attr.data-test-id]="testId + '.assets-label.' + i">Enter Amount</mat-label>
                        <input #assetsLiabilitiesQue="ngModel"
                               [(ngModel)]="question.answer" autocomplete="off"
                               currency-format matInput min-max
                               name="assetsLiabilitiesQue{{i + 1}}" required
                               type="tel"
                               [attr.data-test-id]="testId + '.assets-input.' + i"/>
                        <span matPrefix>$&nbsp;</span>
                        <span matSuffix>.00</span>
                        <mat-error *ngIf="assetsLiabilitiesQue.hasError('required')"
                                   [attr.data-test-id]="testId + '.assets.required-error.' + i">
                            Please enter a valid amount.
                        </mat-error>
                        <mat-error *ngIf="assetsLiabilitiesQue.hasError('min-max')"
                                   [attr.data-test-id]="testId + '.assets.min-max-error.' + i">
                            For amounts over $10,000,000, please contact us.
                        </mat-error>
                    </mat-form-field>
                </savvy-card>
            </div>
        </div>
    </ng-container>

</form>
